import React, { useState, useEffect } from 'react';
import './css/browser-recommendation.css';

const BrowserRecommendation = () => {
  const [showPopup, setShowPopup] = useState(false);
  
  useEffect(() => {
    // Check if the popup has been shown before
    const hasSeenPopup = localStorage.getItem('browserRecommendationShown');
    
    // Check if this is not Chrome
    const isChrome = navigator.userAgent.indexOf("Chrome") !== -1 && 
                    navigator.userAgent.indexOf("Edg") === -1 && 
                    navigator.userAgent.indexOf("OPR") === -1;
    
    // Show the popup only if it hasn't been shown before and the user is not on Chrome
    if (!hasSeenPopup && !isChrome) {
      setShowPopup(true);
    }
  }, []);
  
  const handleAccept = () => {
    window.open('https://www.google.com/chrome/', '_blank');
    setShowPopup(false);
    localStorage.setItem('browserRecommendationShown', 'true');
  };
  
  const handleCancel = () => {
    setShowPopup(false);
    localStorage.setItem('browserRecommendationShown', 'true');
  };
  
  if (!showPopup) return null;
  
  return (
    <div className="browser-recommendation-overlay">
      <div className="browser-recommendation-container">
        <div className="browser-recommendation-content">
          <h2>For the best experience</h2>
          <div className="browser-icons">
            <svg className="app-icon" xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 64 64">
              <defs>
                <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#1a1a1a" stopOpacity="1" />
                  <stop offset="100%" stopColor="#333333" stopOpacity="1" />
                </linearGradient>
                <linearGradient id="gold" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#d4af37" stopOpacity="1" />
                  <stop offset="100%" stopColor="#f2d571" stopOpacity="1" />
                </linearGradient>
              </defs>
              <circle cx="32" cy="32" r="30" fill="url(#grad1)" stroke="url(#gold)" strokeWidth="2" />
              <path d="M12,24 L12,18 L16,18 L16,15 L20,15 L20,12 L24,12 L24,9 L28,9 L28,12 L32,8 L36,12 L36,9 L40,9 L40,12 L44,12 L44,15 L48,15 L48,18 L52,18 L52,24 L52,40 L12,40 Z" 
                    fill="url(#gold)" opacity="0.9" />
              <rect x="16" y="25" width="3" height="5" fill="#333" />
              <rect x="24" y="25" width="3" height="5" fill="#333" />
              <rect x="32" y="25" width="3" height="5" fill="#333" />
              <rect x="40" y="25" width="3" height="5" fill="#333" />
              <rect x="45" y="25" width="3" height="5" fill="#333" />
              <text x="32" y="50" textAnchor="middle" fontFamily="Arial" fontWeight="bold" fontSize="24" fill="url(#gold)">E</text>
            </svg>
          </div>
          <p>We recommend using Google Chrome for the best experience on our site.</p>
          <p className="sub-text">Some features may not work correctly in other browsers.</p>
          <div className="browser-recommendation-actions">
            <button className="accept-button" onClick={handleAccept}>
              Download Chrome
            </button>
            <button className="cancel-button" onClick={handleCancel}>
              Continue anyway
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrowserRecommendation;